
import isEmpty from 'lodash-es/isEmpty';

import { isNullOrUndefined } from '@app/util/util';
import {
  BookingBillingTypeDocumentProps, BusinessRulesByBookingType, BookingPaxTypeDocumentProps
} from '@app/entities/booking-documents';
import { BillingInfo } from '@billing/entities/billing.payload';
import { Travelers } from '@booking/entities/booking-arrangement';
import { BookingDocumentPaxIdType } from '@app/entities/booking-pax-documents-id';
import { BookingDocumentBillingIdType } from '@app/entities/booking-billing-documents-id';

export function disabledBillingCountrySelectorMapper(
  billing: BillingInfo, config: BusinessRulesByBookingType, documents: BookingBillingTypeDocumentProps[]
): boolean {
  const validator = !!config?.ENABLED_BILLING_MODULE_COUNTRY_SELECTOR_ONLY_THESE_DOCUMENTS?.length;
  if (
    !isEmpty(billing) &&
    validator
  ) {
    return disabledBillingSelector(
      documents, billing.configuration_document_id,
      config.ENABLED_BILLING_MODULE_COUNTRY_SELECTOR_ONLY_THESE_DOCUMENTS
    );
  } else return false;
}

export function disabledPaxCountrySelectorMapper(
  pax: Travelers, config: BusinessRulesByBookingType, documents: BookingPaxTypeDocumentProps[]
): boolean {
  const validator = !!config?.ENABLED_PAX_MODULE_COUNTRY_SELECTOR_ONLY_THESE_DOCUMENTS?.length;
  if (
    !isEmpty(pax) &&
    validator
  ) {
    return disabledPaxSelectorByDocument(
      documents, pax.ConfigurationDocumentId,
      config.ENABLED_PAX_MODULE_COUNTRY_SELECTOR_ONLY_THESE_DOCUMENTS
    );
  } else return false;
}

function disabledBillingSelector(
  documents: BookingBillingTypeDocumentProps[], id: number, enabled: BookingDocumentBillingIdType[]
): boolean {
  if (isNullOrUndefined(id) || enabled.includes(BookingDocumentBillingIdType.NONE_ENABLED)) {
    return true;
  } else {
    const document = documents.find(_doc => _doc.DOCUMENT_ID === id);
    return !isEmpty(document) ? !enabled.includes(document.TYPE) : true;
  }
}

function disabledPaxSelectorByDocument(
  documents: BookingPaxTypeDocumentProps[], id: number, enabled: BookingDocumentPaxIdType[]
): boolean {
  if (isNullOrUndefined(id) || enabled.includes(BookingDocumentPaxIdType.NONE_ENABLED)) {
    return true;
  } else {
    const document = documents.find(_doc => _doc.DOCUMENT_ID === id);
    return !isEmpty(document) ? !enabled.includes(document.TYPE) : true;
  }
}

